import { Config } from "@/util/Config";

function initGoogleTagManager() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", Config.GTM_CONTAINER_ID);
}

function initGA4() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", Config.GA4_ID);
}

export { initGoogleTagManager, initGA4 };
